{
  "version": 1,
  "note": "Real surveyed geometry from free public county GIS, translated to fictitious anchors. Addresses, owners and parcel numbers are invented. See src/lib/sample-address-registry.ts.",
  "parcels": [
    {
      "key": "kestrel-hollow",
      "address": "1428 Kestrel Hollow Road",
      "city": "Havenwood",
      "state": "NC",
      "zip": "27502",
      "owner": "Marisol T. Vance",
      "pin": "SAMPLE-0742-KH-1428",
      "acreage": 1.06,
      "parcelRings": [
        [
          [
            35.284483,
            -80.9134358
          ],
          [
            35.2836326,
            -80.9134616
          ],
          [
            35.283629,
            -80.9139642
          ],
          [
            35.2845711,
            -80.9138894
          ],
          [
            35.2845649,
            -80.913866
          ],
          [
            35.2845469,
            -80.9138058
          ],
          [
            35.2845305,
            -80.9137446
          ],
          [
            35.2845169,
            -80.9136826
          ],
          [
            35.2845052,
            -80.9136211
          ],
          [
            35.2844954,
            -80.9135581
          ],
          [
            35.2844878,
            -80.9134955
          ],
          [
            35.284483,
            -80.9134358
          ]
        ]
      ],
      "corridors": [
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement along the south side of the lot",
          "rings": [
            [
              [
                35.2835262,
                -80.9138135
              ],
              [
                35.2835671,
                -80.914109
              ],
              [
                35.2836755,
                -80.9140864
              ],
              [
                35.2836346,
                -80.913791
              ],
              [
                35.2835262,
                -80.9138135
              ]
            ]
          ]
        },
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement along the west side of the lot",
          "rings": [
            [
              [
                35.2839943,
                -80.9143761
              ],
              [
                35.2839302,
                -80.9139138
              ],
              [
                35.2838218,
                -80.9139364
              ],
              [
                35.2838859,
                -80.9143987
              ],
              [
                35.2839943,
                -80.9143761
              ]
            ],
            [
              [
                35.2839302,
                -80.9139138
              ],
              [
                35.2838603,
                -80.913409
              ],
              [
                35.2837519,
                -80.9134316
              ],
              [
                35.2838218,
                -80.9139364
              ],
              [
                35.2839302,
                -80.9139138
              ]
            ]
          ]
        },
        {
          "kind": "row",
          "widthFt": 60,
          "label": "60-foot public road right-of-way along the north side of the lot",
          "rings": [
            [
              [
                35.2844816,
                -80.913375
              ],
              [
                35.2845029,
                -80.9136411
              ],
              [
                35.2846669,
                -80.9136213
              ],
              [
                35.2846456,
                -80.9133552
              ],
              [
                35.2844816,
                -80.913375
              ]
            ],
            [
              [
                35.2845081,
                -80.913668
              ],
              [
                35.2846131,
                -80.9139968
              ],
              [
                35.2847667,
                -80.9139232
              ],
              [
                35.2846617,
                -80.9135944
              ],
              [
                35.2845081,
                -80.913668
              ]
            ],
            [
              [
                35.2846221,
                -80.9140174
              ],
              [
                35.2847787,
                -80.9142951
              ],
              [
                35.2849143,
                -80.9141803
              ],
              [
                35.2847577,
                -80.9139026
              ],
              [
                35.2846221,
                -80.9140174
              ]
            ]
          ]
        }
      ],
      "addressPoint": [
        35.2840681,
        -80.9136927
      ],
      "frame": {
        "minLat": 35.2834026,
        "minLng": -80.9159445,
        "maxLat": 35.2850379,
        "maxLng": -80.9118095
      },
      "image": {
        "file": "sample-aerial-kestrel-hollow.jpg",
        "width": 1600,
        "height": 775,
        "bytes": 254847
      },
      "driftFeet": 0.3
    },
    {
      "key": "sable-ridge",
      "address": "3207 Sable Ridge Lane",
      "city": "Marbry Springs",
      "state": "NC",
      "zip": "27540",
      "owner": "Dennis and Ruth Okoye",
      "pin": "SAMPLE-1180-SR-3207",
      "acreage": 0.67,
      "parcelRings": [
        [
          [
            34.9427613,
            -79.7313913
          ],
          [
            34.9427483,
            -79.7313992
          ],
          [
            34.942244,
            -79.7318148
          ],
          [
            34.9423387,
            -79.7320025
          ],
          [
            34.9424419,
            -79.7322087
          ],
          [
            34.942956,
            -79.7316779
          ],
          [
            34.9427809,
            -79.7314221
          ],
          [
            34.9427613,
            -79.7313913
          ]
        ]
      ],
      "corridors": [
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement along the east side of the lot",
          "rings": [
            [
              [
                34.942285,
                -79.7311509
              ],
              [
                34.9427131,
                -79.7314549
              ],
              [
                34.9427683,
                -79.731339
              ],
              [
                34.9423402,
                -79.731035
              ],
              [
                34.942285,
                -79.7311509
              ]
            ],
            [
              [
                34.942713,
                -79.7314548
              ],
              [
                34.9427475,
                -79.7314794
              ],
              [
                34.9428029,
                -79.7313636
              ],
              [
                34.9427684,
                -79.7313391
              ],
              [
                34.942713,
                -79.7314548
              ]
            ],
            [
              [
                34.9428178,
                -79.7313792
              ],
              [
                34.9428168,
                -79.7313777
              ],
              [
                34.9427316,
                -79.7314623
              ],
              [
                34.9427326,
                -79.7314638
              ],
              [
                34.9428178,
                -79.7313792
              ]
            ],
            [
              [
                34.9428185,
                -79.7313804
              ],
              [
                34.9428182,
                -79.7313799
              ],
              [
                34.9427296,
                -79.7314591
              ],
              [
                34.9427299,
                -79.7314596
              ],
              [
                34.9428185,
                -79.7313804
              ]
            ],
            [
              [
                34.9428172,
                -79.7313783
              ],
              [
                34.9427975,
                -79.7313475
              ],
              [
                34.9427109,
                -79.7314298
              ],
              [
                34.9427306,
                -79.7314607
              ],
              [
                34.9428172,
                -79.7313783
              ]
            ],
            [
              [
                34.9427108,
                -79.7314298
              ],
              [
                34.9427308,
                -79.7314612
              ],
              [
                34.9428176,
                -79.7313788
              ],
              [
                34.9427976,
                -79.7313475
              ],
              [
                34.9427108,
                -79.7314298
              ]
            ]
          ]
        },
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement along the north side of the lot",
          "rings": [
            [
              [
                34.9427466,
                -79.731478
              ],
              [
                34.943165,
                -79.7317745
              ],
              [
                34.9432202,
                -79.7316585
              ],
              [
                34.9428018,
                -79.731362
              ],
              [
                34.9427466,
                -79.731478
              ]
            ]
          ]
        },
        {
          "kind": "row",
          "widthFt": 60,
          "label": "60-foot public road right-of-way off the east line",
          "rings": [
            [
              [
                34.9426452,
                -79.7310979
              ],
              [
                34.9427303,
                -79.7313433
              ],
              [
                34.9428821,
                -79.731265
              ],
              [
                34.942797,
                -79.7310196
              ],
              [
                34.9426452,
                -79.7310979
              ]
            ],
            [
              [
                34.9427413,
                -79.7313661
              ],
              [
                34.9428927,
                -79.7316024
              ],
              [
                34.9430225,
                -79.7314785
              ],
              [
                34.9428711,
                -79.7312422
              ],
              [
                34.9427413,
                -79.7313661
              ]
            ],
            [
              [
                34.942895,
                -79.7316059
              ],
              [
                34.9431203,
                -79.7319267
              ],
              [
                34.9432455,
                -79.7317958
              ],
              [
                34.9430202,
                -79.731475
              ],
              [
                34.942895,
                -79.7316059
              ]
            ]
          ]
        }
      ],
      "addressPoint": [
        34.9425928,
        -79.7317831
      ],
      "frame": {
        "minLat": 34.9421204,
        "minLng": -79.7331862,
        "maxLat": 34.9433691,
        "maxLng": -79.7300421
      },
      "image": {
        "file": "sample-aerial-sable-ridge.jpg",
        "width": 1600,
        "height": 775,
        "bytes": 250356
      },
      "driftFeet": 0.7
    },
    {
      "key": "amberleigh-court",
      "address": "118 Amberleigh Court",
      "city": "Foxglove Station",
      "state": "NC",
      "zip": "27587",
      "owner": "Priya N. Raman",
      "pin": "SAMPLE-2265-AC-0118",
      "acreage": 0.46,
      "parcelRings": [
        [
          [
            36.3711272,
            -79.4023651
          ],
          [
            36.3709608,
            -79.4026283
          ],
          [
            36.3710299,
            -79.4028736
          ],
          [
            36.3710625,
            -79.4028605
          ],
          [
            36.3712446,
            -79.4027821
          ],
          [
            36.3714392,
            -79.4026984
          ],
          [
            36.3712781,
            -79.4021264
          ],
          [
            36.3711272,
            -79.4023651
          ]
        ]
      ],
      "corridors": [
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement off the south line",
          "rings": [
            [
              [
                36.3709074,
                -79.4029509
              ],
              [
                36.3709402,
                -79.4029008
              ],
              [
                36.370855,
                -79.4028148
              ],
              [
                36.3708222,
                -79.4028649
              ],
              [
                36.3709074,
                -79.4029509
              ]
            ],
            [
              [
                36.3709399,
                -79.4029013
              ],
              [
                36.3710254,
                -79.4027731
              ],
              [
                36.3709408,
                -79.4026861
              ],
              [
                36.3708553,
                -79.4028143
              ],
              [
                36.3709399,
                -79.4029013
              ]
            ],
            [
              [
                36.3710272,
                -79.4027702
              ],
              [
                36.3710885,
                -79.4026675
              ],
              [
                36.3710003,
                -79.4025863
              ],
              [
                36.370939,
                -79.402689
              ],
              [
                36.3710272,
                -79.4027702
              ]
            ],
            [
              [
                36.3710876,
                -79.4026691
              ],
              [
                36.3711486,
                -79.402573
              ],
              [
                36.3710622,
                -79.4024885
              ],
              [
                36.3710012,
                -79.4025847
              ],
              [
                36.3710876,
                -79.4026691
              ]
            ],
            [
              [
                36.3711485,
                -79.402573
              ],
              [
                36.3711889,
                -79.4025095
              ],
              [
                36.3711027,
                -79.4024249
              ],
              [
                36.3710623,
                -79.4024885
              ],
              [
                36.3711485,
                -79.402573
              ]
            ]
          ]
        },
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement crossing the lot",
          "rings": [
            [
              [
                36.3711984,
                -79.4024473
              ],
              [
                36.3711741,
                -79.4023482
              ],
              [
                36.3710689,
                -79.402388
              ],
              [
                36.3710932,
                -79.4024871
              ],
              [
                36.3711984,
                -79.4024473
              ]
            ],
            [
              [
                36.3711723,
                -79.4023942
              ],
              [
                36.3711724,
                -79.4023939
              ],
              [
                36.3710708,
                -79.4023417
              ],
              [
                36.3710707,
                -79.402342
              ],
              [
                36.3711723,
                -79.4023942
              ]
            ],
            [
              [
                36.3710698,
                -79.4023904
              ],
              [
                36.3710923,
                -79.40247
              ],
              [
                36.3711959,
                -79.4024248
              ],
              [
                36.3711734,
                -79.4023452
              ],
              [
                36.3710698,
                -79.4023904
              ]
            ],
            [
              [
                36.3711989,
                -79.4024517
              ],
              [
                36.3712022,
                -79.4023872
              ],
              [
                36.3710926,
                -79.4023786
              ],
              [
                36.3710893,
                -79.4024431
              ],
              [
                36.3711989,
                -79.4024517
              ]
            ],
            [
              [
                36.3710925,
                -79.4023813
              ],
              [
                36.3710909,
                -79.4024656
              ],
              [
                36.3712007,
                -79.4024688
              ],
              [
                36.3712023,
                -79.4023845
              ],
              [
                36.3710925,
                -79.4023813
              ]
            ],
            [
              [
                36.3711889,
                -79.4025095
              ],
              [
                36.3712881,
                -79.4023534
              ],
              [
                36.3712019,
                -79.4022688
              ],
              [
                36.3711027,
                -79.4024249
              ],
              [
                36.3711889,
                -79.4025095
              ]
            ],
            [
              [
                36.3712881,
                -79.4023534
              ],
              [
                36.3713074,
                -79.4023231
              ],
              [
                36.3712212,
                -79.4022385
              ],
              [
                36.3712019,
                -79.4022688
              ],
              [
                36.3712881,
                -79.4023534
              ]
            ]
          ]
        },
        {
          "kind": "row",
          "widthFt": 60,
          "label": "60-foot public road right-of-way off the north line",
          "rings": [
            [
              [
                36.3718024,
                -79.4025673
              ],
              [
                36.3717147,
                -79.4025877
              ],
              [
                36.3717451,
                -79.402789
              ],
              [
                36.3718328,
                -79.4027686
              ],
              [
                36.3718024,
                -79.4025673
              ]
            ],
            [
              [
                36.3717111,
                -79.4025887
              ],
              [
                36.3716259,
                -79.4026134
              ],
              [
                36.3716635,
                -79.4028128
              ],
              [
                36.3717487,
                -79.402788
              ],
              [
                36.3717111,
                -79.4025887
              ]
            ],
            [
              [
                36.3716237,
                -79.4026141
              ],
              [
                36.3715396,
                -79.4026417
              ],
              [
                36.3715816,
                -79.4028396
              ],
              [
                36.3716657,
                -79.4028121
              ],
              [
                36.3716237,
                -79.4026141
              ]
            ],
            [
              [
                36.3715352,
                -79.4026433
              ],
              [
                36.3714417,
                -79.402681
              ],
              [
                36.3714925,
                -79.4028757
              ],
              [
                36.371586,
                -79.402838
              ],
              [
                36.3715352,
                -79.4026433
              ]
            ],
            [
              [
                36.37144,
                -79.4026817
              ],
              [
                36.3711147,
                -79.4028223
              ],
              [
                36.3711689,
                -79.4030157
              ],
              [
                36.3714942,
                -79.402875
              ],
              [
                36.37144,
                -79.4026817
              ]
            ],
            [
              [
                36.3711167,
                -79.4028215
              ],
              [
                36.3710216,
                -79.4028593
              ],
              [
                36.3710718,
                -79.4030542
              ],
              [
                36.3711669,
                -79.4030165
              ],
              [
                36.3711167,
                -79.4028215
              ]
            ],
            [
              [
                36.3710257,
                -79.4028578
              ],
              [
                36.3709591,
                -79.4028796
              ],
              [
                36.3710011,
                -79.4030775
              ],
              [
                36.3710677,
                -79.4030557
              ],
              [
                36.3710257,
                -79.4028578
              ]
            ],
            [
              [
                36.3709658,
                -79.4028777
              ],
              [
                36.3708992,
                -79.4028923
              ],
              [
                36.3709278,
                -79.4030939
              ],
              [
                36.3709944,
                -79.4030794
              ],
              [
                36.3709658,
                -79.4028777
              ]
            ],
            [
              [
                36.3709067,
                -79.4028911
              ],
              [
                36.3708354,
                -79.4028984
              ],
              [
                36.370849,
                -79.4031024
              ],
              [
                36.3709203,
                -79.4030951
              ],
              [
                36.3709067,
                -79.4028911
              ]
            ]
          ]
        }
      ],
      "addressPoint": [
        36.3712012,
        -79.4025593
      ],
      "frame": {
        "minLat": 36.3706986,
        "minLng": -79.4042265,
        "maxLat": 36.3719564,
        "maxLng": -79.4010023
      },
      "image": {
        "file": "sample-aerial-amberleigh-court.jpg",
        "width": 1600,
        "height": 775,
        "bytes": 249824
      },
      "driftFeet": 1.2
    },
    {
      "key": "juniper-fork",
      "address": "6215 Juniper Fork Road",
      "city": "Larkin Ford",
      "state": "NC",
      "zip": "27526",
      "owner": "Walter J. Brightwell",
      "pin": "SAMPLE-3391-JF-6215",
      "acreage": 2.05,
      "parcelRings": [
        [
          [
            35.1184802,
            -78.2257335
          ],
          [
            35.1180861,
            -78.226175
          ],
          [
            35.1191092,
            -78.2270665
          ],
          [
            35.1191837,
            -78.2269788
          ],
          [
            35.1194766,
            -78.2266433
          ],
          [
            35.1195139,
            -78.2265991
          ],
          [
            35.1191908,
            -78.2263238
          ],
          [
            35.1190788,
            -78.2262273
          ],
          [
            35.1186683,
            -78.2258786
          ],
          [
            35.1186126,
            -78.2258334
          ],
          [
            35.1184802,
            -78.2257335
          ]
        ]
      ],
      "corridors": [
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement off the east line",
          "rings": [
            [
              [
                35.1195727,
                -78.2252938
              ],
              [
                35.1196258,
                -78.2253472
              ],
              [
                35.1196956,
                -78.2252434
              ],
              [
                35.1196425,
                -78.22519
              ],
              [
                35.1195727,
                -78.2252938
              ]
            ],
            [
              [
                35.119615,
                -78.225258
              ],
              [
                35.1196147,
                -78.2252586
              ],
              [
                35.1197061,
                -78.2253331
              ],
              [
                35.1197064,
                -78.2253326
              ],
              [
                35.119615,
                -78.225258
              ]
            ],
            [
              [
                35.119695,
                -78.2252437
              ],
              [
                35.1196418,
                -78.2251909
              ],
              [
                35.1195726,
                -78.2252952
              ],
              [
                35.1196258,
                -78.225348
              ],
              [
                35.119695,
                -78.2252437
              ]
            ],
            [
              [
                35.1195639,
                -78.2252017
              ],
              [
                35.1194259,
                -78.2254175
              ],
              [
                35.1195125,
                -78.2255002
              ],
              [
                35.1196505,
                -78.2252844
              ],
              [
                35.1195639,
                -78.2252017
              ]
            ],
            [
              [
                35.1194261,
                -78.2254172
              ],
              [
                35.1193036,
                -78.2256065
              ],
              [
                35.1193898,
                -78.2256898
              ],
              [
                35.1195123,
                -78.2255005
              ],
              [
                35.1194261,
                -78.2254172
              ]
            ],
            [
              [
                35.1193174,
                -78.225705
              ],
              [
                35.119376,
                -78.2257501
              ],
              [
                35.1194346,
                -78.2256365
              ],
              [
                35.119376,
                -78.2255913
              ],
              [
                35.1193174,
                -78.225705
              ]
            ],
            [
              [
                35.119361,
                -78.2256536
              ],
              [
                35.1193604,
                -78.2256546
              ],
              [
                35.119449,
                -78.225734
              ],
              [
                35.1194496,
                -78.225733
              ],
              [
                35.119361,
                -78.2256536
              ]
            ],
            [
              [
                35.1194344,
                -78.2256378
              ],
              [
                35.1193765,
                -78.2255923
              ],
              [
                35.1193171,
                -78.2257052
              ],
              [
                35.119375,
                -78.2257508
              ],
              [
                35.1194344,
                -78.2256378
              ]
            ],
            [
              [
                35.1193036,
                -78.2256073
              ],
              [
                35.1189677,
                -78.2261306
              ],
              [
                35.1190541,
                -78.2262135
              ],
              [
                35.11939,
                -78.2256902
              ],
              [
                35.1193036,
                -78.2256073
              ]
            ],
            [
              [
                35.1189677,
                -78.2261306
              ],
              [
                35.1188601,
                -78.2262983
              ],
              [
                35.1189465,
                -78.2263812
              ],
              [
                35.1190541,
                -78.2262135
              ],
              [
                35.1189677,
                -78.2261306
              ]
            ],
            [
              [
                35.1188601,
                -78.2262983
              ],
              [
                35.1186388,
                -78.226643
              ],
              [
                35.1187252,
                -78.226726
              ],
              [
                35.1189465,
                -78.2263812
              ],
              [
                35.1188601,
                -78.2262983
              ]
            ],
            [
              [
                35.1186481,
                -78.2267374
              ],
              [
                35.1186826,
                -78.2267704
              ],
              [
                35.1187504,
                -78.2266647
              ],
              [
                35.1187159,
                -78.2266316
              ],
              [
                35.1186481,
                -78.2267374
              ]
            ],
            [
              [
                35.1187496,
                -78.226664
              ],
              [
                35.1187148,
                -78.2266318
              ],
              [
                35.1186486,
                -78.226739
              ],
              [
                35.1186834,
                -78.2267711
              ],
              [
                35.1187496,
                -78.226664
              ]
            ],
            [
              [
                35.1186385,
                -78.2266438
              ],
              [
                35.1185606,
                -78.2267647
              ],
              [
                35.118647,
                -78.2268478
              ],
              [
                35.1187249,
                -78.226727
              ],
              [
                35.1186385,
                -78.2266438
              ]
            ]
          ]
        },
        {
          "kind": "utility",
          "widthFt": 40,
          "label": "40-foot recorded utility easement off the west line",
          "rings": [
            [
              [
                35.11867,
                -78.2272324
              ],
              [
                35.1186698,
                -78.2272323
              ],
              [
                35.1186124,
                -78.2273468
              ],
              [
                35.1186126,
                -78.227347
              ],
              [
                35.11867,
                -78.2272324
              ]
            ],
            [
              [
                35.1186842,
                -78.2273312
              ],
              [
                35.1188554,
                -78.2270666
              ],
              [
                35.1187692,
                -78.2269832
              ],
              [
                35.118598,
                -78.2272479
              ],
              [
                35.1186842,
                -78.2273312
              ]
            ],
            [
              [
                35.1188481,
                -78.2269739
              ],
              [
                35.1187958,
                -78.226919
              ],
              [
                35.1187242,
                -78.227021
              ],
              [
                35.1187765,
                -78.2270759
              ],
              [
                35.1188481,
                -78.2269739
              ]
            ],
            [
              [
                35.1188017,
                -78.2270137
              ],
              [
                35.1188024,
                -78.2270127
              ],
              [
                35.118719,
                -78.2269253
              ],
              [
                35.1187183,
                -78.2269263
              ],
              [
                35.1188017,
                -78.2270137
              ]
            ],
            [
              [
                35.1187251,
                -78.2270202
              ],
              [
                35.1187773,
                -78.2270744
              ],
              [
                35.1188485,
                -78.226972
              ],
              [
                35.1187963,
                -78.2269178
              ],
              [
                35.1187251,
                -78.2270202
              ]
            ],
            [
              [
                35.118856,
                -78.2270649
              ],
              [
                35.1189439,
                -78.226929
              ],
              [
                35.1188577,
                -78.2268457
              ],
              [
                35.1187698,
                -78.2269815
              ],
              [
                35.118856,
                -78.2270649
              ]
            ],
            [
              [
                35.1189356,
                -78.2268354
              ],
              [
                35.1189354,
                -78.2268352
              ],
              [
                35.1188658,
                -78.2269391
              ],
              [
                35.118866,
                -78.2269393
              ],
              [
                35.1189356,
                -78.2268354
              ]
            ],
            [
              [
                35.1189438,
                -78.2269286
              ],
              [
                35.1191546,
                -78.2266001
              ],
              [
                35.1190682,
                -78.2265172
              ],
              [
                35.1188574,
                -78.2268457
              ],
              [
                35.1189438,
                -78.2269286
              ]
            ],
            [
              [
                35.1191546,
                -78.2266001
              ],
              [
                35.1192769,
                -78.2264096
              ],
              [
                35.1191905,
                -78.2263267
              ],
              [
                35.1190682,
                -78.2265172
              ],
              [
                35.1191546,
                -78.2266001
              ]
            ],
            [
              [
                35.1192769,
                -78.2264096
              ],
              [
                35.1196218,
                -78.2258723
              ],
              [
                35.1195354,
                -78.2257893
              ],
              [
                35.1191905,
                -78.2263267
              ],
              [
                35.1192769,
                -78.2264096
              ]
            ],
            [
              [
                35.1196083,
                -78.2257743
              ],
              [
                35.1195504,
                -78.2257288
              ],
              [
                35.119491,
                -78.2258417
              ],
              [
                35.1195489,
                -78.2258873
              ],
              [
                35.1196083,
                -78.2257743
              ]
            ],
            [
              [
                35.1195645,
                -78.2258258
              ],
              [
                35.1195658,
                -78.2258237
              ],
              [
                35.1194782,
                -78.2257426
              ],
              [
                35.1194769,
                -78.2257447
              ],
              [
                35.1195645,
                -78.2258258
              ]
            ],
            [
              [
                35.1194928,
                -78.22584
              ],
              [
                35.1195509,
                -78.2258847
              ],
              [
                35.1196093,
                -78.2257709
              ],
              [
                35.1195512,
                -78.2257263
              ],
              [
                35.1194928,
                -78.22584
              ]
            ],
            [
              [
                35.1196232,
                -78.2258695
              ],
              [
                35.1197372,
                -78.2256933
              ],
              [
                35.119651,
                -78.22561
              ],
              [
                35.119537,
                -78.2257861
              ],
              [
                35.1196232,
                -78.2258695
              ]
            ],
            [
              [
                35.1197375,
                -78.2256929
              ],
              [
                35.1198627,
                -78.2254963
              ],
              [
                35.1197759,
                -78.2254138
              ],
              [
                35.1196507,
                -78.2256104
              ],
              [
                35.1197375,
                -78.2256929
              ]
            ],
            [
              [
                35.1197724,
                -78.2254901
              ],
              [
                35.1197725,
                -78.2254903
              ],
              [
                35.1198663,
                -78.2254202
              ],
              [
                35.1198662,
                -78.22542
              ],
              [
                35.1197724,
                -78.2254901
              ]
            ],
            [
              [
                35.1198625,
                -78.2254969
              ],
              [
                35.1199397,
                -78.2253775
              ],
              [
                35.1198535,
                -78.2252942
              ],
              [
                35.1197763,
                -78.2254136
              ],
              [
                35.1198625,
                -78.2254969
              ]
            ]
          ]
        },
        {
          "kind": "row",
          "widthFt": 50,
          "label": "50-foot public road right-of-way along the south side of the lot",
          "rings": [
            [
              [
                35.1179033,
                -78.2262057
              ],
              [
                35.1181044,
                -78.2263837
              ],
              [
                35.118185,
                -78.2262477
              ],
              [
                35.1179839,
                -78.2260697
              ],
              [
                35.1179033,
                -78.2262057
              ]
            ],
            [
              [
                35.1180952,
                -78.2263739
              ],
              [
                35.1182024,
                -78.2265101
              ],
              [
                35.1183014,
                -78.2263937
              ],
              [
                35.1181942,
                -78.2262575
              ],
              [
                35.1180952,
                -78.2263739
              ]
            ],
            [
              [
                35.1182003,
                -78.2265073
              ],
              [
                35.118291,
                -78.2266335
              ],
              [
                35.1183942,
                -78.2265226
              ],
              [
                35.1183035,
                -78.2263965
              ],
              [
                35.1182003,
                -78.2265073
              ]
            ],
            [
              [
                35.1182868,
                -78.226627
              ],
              [
                35.1183725,
                -78.2267731
              ],
              [
                35.1184841,
                -78.2266753
              ],
              [
                35.1183984,
                -78.2265291
              ],
              [
                35.1182868,
                -78.226627
              ]
            ],
            [
              [
                35.1183748,
                -78.2267768
              ],
              [
                35.1184853,
                -78.226945
              ],
              [
                35.1185923,
                -78.2268398
              ],
              [
                35.1184818,
                -78.2266716
              ],
              [
                35.1183748,
                -78.2267768
              ]
            ],
            [
              [
                35.1184855,
                -78.2269454
              ],
              [
                35.1186241,
                -78.2271536
              ],
              [
                35.1187307,
                -78.2270477
              ],
              [
                35.1185921,
                -78.2268394
              ],
              [
                35.1184855,
                -78.2269454
              ]
            ],
            [
              [
                35.1186255,
                -78.2271557
              ],
              [
                35.1187689,
                -78.2273579
              ],
              [
                35.1188727,
                -78.2272478
              ],
              [
                35.1187293,
                -78.2270456
              ],
              [
                35.1186255,
                -78.2271557
              ]
            ],
            [
              [
                35.1187727,
                -78.2273628
              ],
              [
                35.1188916,
                -78.2275055
              ],
              [
                35.1189878,
                -78.2273856
              ],
              [
                35.1188689,
                -78.2272429
              ],
              [
                35.1187727,
                -78.2273628
              ]
            ]
          ]
        },
        {
          "kind": "row",
          "widthFt": 80,
          "label": "80-foot public road right-of-way off the north line",
          "rings": [
            [
              [
                35.1198115,
                -78.2262195
              ],
              [
                35.1196849,
                -78.226372
              ],
              [
                35.1198391,
                -78.2265634
              ],
              [
                35.1199657,
                -78.2264109
              ],
              [
                35.1198115,
                -78.2262195
              ]
            ],
            [
              [
                35.1196878,
                -78.2263686
              ],
              [
                35.1195161,
                -78.2265605
              ],
              [
                35.1196645,
                -78.2267588
              ],
              [
                35.1198362,
                -78.2265668
              ],
              [
                35.1196878,
                -78.2263686
              ]
            ],
            [
              [
                35.1195154,
                -78.2265614
              ],
              [
                35.1193071,
                -78.2267989
              ],
              [
                35.1194569,
                -78.2269954
              ],
              [
                35.1196652,
                -78.2267579
              ],
              [
                35.1195154,
                -78.2265614
              ]
            ],
            [
              [
                35.1193071,
                -78.2267989
              ],
              [
                35.1191574,
                -78.2269695
              ],
              [
                35.1193072,
                -78.227166
              ],
              [
                35.1194569,
                -78.2269954
              ],
              [
                35.1193071,
                -78.2267989
              ]
            ],
            [
              [
                35.1191563,
                -78.2269707
              ],
              [
                35.1190362,
                -78.2271112
              ],
              [
                35.1191882,
                -78.2273054
              ],
              [
                35.1193083,
                -78.2271648
              ],
              [
                35.1191563,
                -78.2269707
              ]
            ],
            [
              [
                35.1190314,
                -78.2271173
              ],
              [
                35.1189377,
                -78.2272416
              ],
              [
                35.1190993,
                -78.2274237
              ],
              [
                35.119193,
                -78.2272993
              ],
              [
                35.1190314,
                -78.2271173
              ]
            ],
            [
              [
                35.1189349,
                -78.2272455
              ],
              [
                35.1188561,
                -78.2273584
              ],
              [
                35.1190233,
                -78.2275328
              ],
              [
                35.1191021,
                -78.2274198
              ],
              [
                35.1189349,
                -78.2272455
              ]
            ]
          ]
        }
      ],
      "addressPoint": [
        35.1188015,
        -78.2263941
      ],
      "frame": {
        "minLat": 35.1177797,
        "minLng": -78.2292744,
        "maxLat": 35.1200893,
        "maxLng": -78.2234463
      },
      "image": {
        "file": "sample-aerial-juniper-fork.jpg",
        "width": 1600,
        "height": 775,
        "bytes": 238791
      },
      "driftFeet": 1.7
    }
  ]
}
